export const MAX_PAGES = 1;
export const MIN_PAGES = 1;
export const MAX_MESSAGES_PER_PAGE = 4;
export const MAX_MESSAGES_PER_PAGE_FOR_ONE_PAGE_COMIC = 4;
export const MIN_COMIC_DESCRIPTION_CHARACTERS = 10;
export const MAX_COMIC_DESCRIPTION_CHARACTERS = 2000;
export const MAX_REGENERATION_INSTRUCTION_CHARACTERS = 500;
export const BUBBLE_MESSAGE_CHARACTER_LIMIT = 160;
export const BUBBLE_MESSAGE_CHARACTER_LIMIT_FOR_ONE_PAGE_COMIC = 160;
export const COMIC_PANEL_COUNT = 4;
export const COMIC_TITLE_CHARACTER_LIMIT = 70;
export const DEFAULT_CHARACTER_ID = 'storyteller';

export const LANGUAGES = {
  Serbian: 'sr',
  English: 'en',
  Slovenian: 'sl',
};
